<textarea class="animate__animated animate__fadeIn search-text-area" placeholder="{{'gen_search' | translate}}" [hidden]="!showSearch" [formControl]="searchControl" (keydown)="onEnter($event)"></textarea>
<div class="d-inline-block px-4 cursor-po-c" (click)="showSearch = !showSearch">
    <a>
        <i class="fa fa-search"></i>
    </a>
</div>